export enum GeoOverrideHeader {
  THM_IP = 'thm-connecting-ip',
  THM_COUNTRY = 'thm-ipcountry',
  THM_TIMEZONE = 'thm-timezone',
  THM_REGIONCODE = 'thm-region-code',
  THM_POSTALCODE = 'thm-postal-code',
}
